<template>
  <div class="kyc-confirm">
    <div class="kyc-confirm__icon">
      <div class="kyc-confirm__icon-ring">
        <div class="kyc-confirm__icon-circle">
          <Icon :name="'shield-check'" :active="false" class="kyc-confirm__shield-svg" />
        </div>
      </div>
    </div>
    <p class="kyc-confirm__text neue">{{ $t('components.service.modal.KycConfirm.1') }}</p>
    <div class="kyc-confirm__actions">
      <button class="kyc-confirm__btn-primary neue" @click="confirm">
        {{ $t('components.service.modal.KycConfirm.2') }}
      </button>
      <button class="kyc-confirm__btn-secondary neue" @click="later">
        {{ $t('components.service.modal.KycConfirm.3') }}
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';

export default {
  components: { Icon },
  props: {
    close: [Function],
  },
  data() {
    return {
      content: this.$store.state.modal.content,
    };
  },
  methods: {
    confirm() {
      this.close();
      this.$router.push('/kyc');
    },
    later() {
      if (this.content?.onLater) {
        this.content.onLater();
      }
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.kyc-confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 40px 40px;
  text-align: center;

  &__icon {
    margin-bottom: 32px;
  }

  &__icon-ring {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: $dark-orange;
    background-color: color-mix(in srgb, #{$dark-orange} 15%, transparent);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__icon-circle {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: $dark-orange;
    display: flex;
    align-items: center;
    justify-content: center;

    .kyc-confirm__shield-svg {
      width: 32px;
      height: 32px;

      :deep(svg) {
        width: 32px;
        height: 32px;
      }
    }
  }

  &__text {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    margin-bottom: 40px;
    max-width: 460px;
  }

  &__actions {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  &__btn-primary {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $dark-orange;
    color: #FFFFFF;
    border: none;
    border-radius: 8px;
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: $dark-orange-hover;
    }
  }

  &__btn-secondary {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    color: #808080;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #F5F5F5;
    }
  }
}
</style>
